import Vue from 'vue';
import store from '@/store';
import { roles } from '@/shared/constants';

export default () => {
  return {
    items: [
      {
        name: Vue.prototype.$tk('nav.administration_nav_title'),
        url: '/administration',
        icon: 'icon-settings',
        role: '',
        disableOffline: true,
        children: [
          {
            name: Vue.prototype.$tk('nav.users_list_title'),
            url: '/administration/users',
            role: roles.SIS_ADMIN,
            disableOffline: true,
          },
          {
            name: Vue.prototype.$tk('nav.roles_list_title'),
            url: '/administration/roles',
            role: roles.SIS_ADMIN,
            disableOffline: true,
          },
          {
            name: Vue.prototype.$tk('nav.audit_logs_list_title'),
            url: '/administration/audit-logs',
            role: roles.SIS_ADMIN,
            disableOffline: true,
          },
          {
            name: Vue.prototype.$tk('nav.error_reports_list_title'),
            url: '/administration/error-reports',
            role: roles.SIS_ADMIN,
            disableOffline: true,
          },
          // {
          //   name: Vue.prototype.$tk('nav.languages_list_title'),
          //   url: '/administration/languages',
          //   role: '',
          //   disableOffline: true,
          // },
          // {
          //   name: Vue.prototype.$tk('nav.translations_list_title'),
          //   url: '/administration/translations',
          //   role: '',
          //   disableOffline: true,
          // },
        ]
      },
      // {
      //   name: Vue.prototype.$tk('nav.dashboard_nav_title'),
      //   url: '/dashboard',
      //   role: '',
      //   icon: 'icon-speedometer',
      //   badge: {
      //     variant: 'primary',
      //     text: 'NEW'
      //   }
      // },
      // {
      //   name: Vue.prototype.$tk('nav.time_logs_list_title'),
      //   url: '/time_logs',
      //   role: '',
      // },
      // {
      //   name: Vue.prototype.$tk('nav.passwords_list_title'),
      //   url: '/passwords',
      //   role: '',
      // },
      // {
      //   name: Vue.prototype.$tk('nav.identities_list_title'),
      //   url: '/identities',
      //   role: '',
      // },
    ]
  };
};
